// **  Initial State
const initialState = {};

const establishmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_ESTABLISHMENT_INFO':
      return action.data;
    case 'UPDATE_ESTABLISHMENT_INFO':
      return {
        ...state,
        ...action.data,
      };
    case 'CLEAR_ESTABLISHMENT_INFO':
      return initialState;
    default:
      return state;
  }
};

export default establishmentReducer;
